(function() {
    'use strict';

    angular.module('appliances.constants', [])
        .constant('appliancesMessagesConst', {
            add: 'Dodano nowe zastosowanie!',
            update: 'Dane zastosowania zostały zaktualizowane!',
            delete: 'Zastosowanie zostało usunięte!',
            error: 'Wystąpił bład!'
        })
        .constant('appliancesPermissionsConst', {
            view: {
                value: 'view_appliance',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu zastosowania!'
            },
            add: {
                value: 'add_appliance',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania zastosowania!'
            },
            update: {
                value: 'change_appliance',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji zastosowania!'
            },
            delete: {
                value: 'delete_appliance',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania zastosowania!'
            }
        });
})();
